<template>
  <!-- <div class="gw_color_note"> -->
  <!-- v-on="$listeners" -->
  <GwMenu
    ref="gwmenu"
    v-bind="gwMenuProps"
    @keydown.stop.enter="apply"
    @open="handleOpen"
  >
    <template #opener>
      <div
        v-if="hasOpener && player"
        class="gw_clrdot traresmenu_opener"
        :style="`--clr-dot:${player.color_hex || 'transparent'}`"
      />
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu"
        tabindex="1"
        @keydown.stop.escape.exact.prevent="methods.toogleOpen(false)"
        @keydown.stop.enter.exact.prevent="updatePlayer(), methods.toogleOpen(false)"
      >
        <!-- <div class="f-center"> -->
        <div class="text-normal capitalize weight_700 mb-2">
          {{ player.name }}
        </div>

        <!-- <div
            class="gw_btn weight_500 ml-auto"
            @click="
              resetPlayer()
              methods.toggleOpen(false)
            "
          >
            <i class="mdi mdi-replay mr-1"></i>
            {{ $t('btn.reset') }}
          </div> -->
        <!-- </div> -->
        <div class="gw_input_label clr-grey">
          {{ $t('common.color') }}
        </div>
        <GwColorPicker
          :value="(l_player || player).color_hex || 'transparent'"
          :hasColorPicker="false"
          :hasColors="true"
          :hasConfirmBtns="false"
          :instaApply="true"
          @update:hex="hex => updateLocalPlayer({ player: l_player || player, color_hex: hex })"
        ></GwColorPicker>
        <div
          class="gw_input_wrapper mt-2"
          :class="{ gw_input_error: (l_player || player).note.length > 500 }"
        >
          <div class="gw_input_label">
            {{ $t('common.note') }}
          </div>
          <textarea
            ref="note"
            style="--input-height: 10rem"
            :contenteditable="true"
            :value="(l_player || player).note"
            class="textarea_note"
            @input="e => updateLocalPlayer({ player: l_player || player, note: e.target.value })"
            @keydown.stop.enter.exact.prevent="updatePlayer(), methods.toggleOpen(false)"
            @keydown.stop.enter.shift.exact.prevent="
              updateLocalPlayer({ player, note: ((l_player || player).note += '\n') })
            "
          ></textarea>
          <div class="gw_input_error_message">
            {{
              $t(`messages.note_too_many_characters`, {
                max_chars: 500,
              })
            }}
          </div>
        </div>
        <div class="d-flex mt-2">
          <div
            class="gw_btn weight_500 mr-auto"
            @click="resetPlayer(), methods.toggleOpen(false)"
          >
            <i class="mdi mdi-replay mr-1"></i>
            {{ $t('btn.reset') }}
          </div>
          <!-- <div
            class="gw_btn weight_500 ml-auto"
            @click="methods.toggleOpen(false)"
          >
            {{ $t('btn.close') }}
          </div> -->
          <div
            class="gw_btn weight_500 gw_btn_primary ml-2"
            @click="updatePlayer(), methods.toggleOpen(false)"
          >
            {{ $t('btn.confirm') }}
          </div>
        </div>
      </div>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import GwColorPicker from '@/components/lib/GwColorPicker'
import { getLabelColors } from '@/helpers/constants'

export default {
  name: 'HaPlayerClrMenu',
  components: {
    GwMenu,
    GwColorPicker,
  },
  props: {
    player: { Object, required: true },
    hasOpener: { default: true },
    gwMenuProps: { default: () => ({}) },
  }, 
 emits: ['update:player'],
  data() {
    return {
      l_player: null,
    }
  },
  methods: {
    handleOpen() {
      if (!this.$refs.note) return
      this.$refs.note.focus()

      this.updateLocalPlayer({ player: this.player })
    },
    updatePlayer() {
      this.$emit('update:player', { player: this.l_player || this.player })
    },
    resetPlayer() {
      this.$emit('update:player', { player: { ...this.player, color_hex: '', note: '' } })
    },
    updateLocalPlayer({ player, color_hex, note }) {
      this.l_player = { ...player }
      this.l_player.color_hex = color_hex ?? (this.l_player.color_hex || getLabelColors()[0])
      this.l_player.note = note ?? this.l_player.note
    },
    toggleOpen(bool, e) {
      if (this.$refs) {
        this.$refs.gwmenu.toggleOpen(bool, e)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.player_color_note {
  display: flex;
  flex-direction: column;
}
</style>
